export class Serializable {
    toJSON() : any {
        let obj = {};
        let keys = Object.getOwnPropertyNames(this.constructor.prototype);
        for (let i = 0; i < keys.length; i++) {
            obj[keys[i]] = this[keys[i]];
        }
        return obj;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/serializable.ts
 **/